export default __webpack_public_path__ + "static/media/java-img.5e8cb917.svg";